import {
 Informations,
 InformationSectionTwo,
 InformationSectionThree,
 InformationSectionFour,
 Pricing
} from "../../components";

import {
 homeObjectiveOne,
 homeObjectiveTwo,
 homeObjectiveThree,
 homeObjectiveFour
} from "./Data";

const Home = () => {
    return (
        <>
            <Informations {...homeObjectiveOne} />
            <InformationSectionTwo {...homeObjectiveTwo} />
            <InformationSectionThree {...homeObjectiveThree} />
            <InformationSectionFour {...homeObjectiveFour} />
            <Pricing />
        </>
    );
}

export default Home;
 